import React from "react";
import PageLayout from "../../Components/PageLayout";
function Documents() {
    return (
        <PageLayout title="Files" subtitle="Documents overview">
            <div className="container flex col box-container">
                {/* <div className="box">Documents</div>
                <div className="box">Documents</div>
                <div className="box">Documents</div> */}
            </div>
        </PageLayout> 
       
    );
}

export default Documents;
